import React from 'react'
import { ImpactDashboardActivity } from 'Generated/graphql-types'
import { MetricsCard } from '../MetricsCard/MetricsCard'
import { MetricsCardContainer } from '../MetricsCard/MetricsCard.styled'
import { getResourceCounts } from '../utils'
import { WithWidgetLoading } from '../WithWidgetLoading'

type AcademyMetricsProps = {
  loading: boolean
  userResourceActivity: ImpactDashboardActivity[]
}

export const AcademyMetrics = ({
  loading,
  userResourceActivity,
}: AcademyMetricsProps) => {
  const {
    totalResourcesViewed,
    coursesViewed,
    templatesViewed,
    articlesViewed,
  } = getResourceCounts(userResourceActivity)

  const metricDetails = [
    { title: 'Total Resources Viewed', value: totalResourcesViewed },
    { title: 'Courses Viewed', value: coursesViewed },
    { title: 'Templates Viewed', value: templatesViewed },
    { title: 'Articles Viewed', value: articlesViewed },
  ]
  return (
    <WithWidgetLoading
      loading={loading}
      width='100%'
      height={loading ? '300px' : 'auto'}
    >
      <MetricsCardContainer>
        {metricDetails.map((metric) => (
          <MetricsCard
            key={metric.title}
            title={metric.title}
            value={metric.value}
          />
        ))}
      </MetricsCardContainer>
    </WithWidgetLoading>
  )
}
